import React from 'react'
import RichCta from 'components/rich-cta'
import config from 'config'
import MortgageCombinedForm from 'components/form/mortgage-combined'
import WidgetPage from 'components/hocs/widget-page'

const RichCtaApp = props => (
  <RichCta
    nmls
    url={`${config.credibleRoot}/mortgage-refinance`}
    title="Find the right mortgage for your dream home."
    body="Get pre-approved and compare rates from 6 lenders in minutes."
    ctaText="Get Started"
    form={MortgageCombinedForm}
    {...props}
  />
)

export default WidgetPage(RichCtaApp)
